import { render } from "./NumberAnswer.vue?vue&type=template&id=6c6e7a09"
import script from "./NumberAnswer.vue?vue&type=script&lang=js"
export * from "./NumberAnswer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__